/** Keep the last successful results visible when a background refresh fails. */
export function RefreshError({
  error,
  onRetry,
}: {
  error: Error | null;
  onRetry: () => void;
}) {
  if (!error) return null;
  return (
    <p
      role="status"
      className="shrink-0 border-b border-line px-4 py-2 text-xs text-err"
    >
      Could not refresh. Showing the last loaded results.{' '}
      <button type="button" className="underline" onClick={onRetry}>
        Retry
      </button>
    </p>
  );
}
